import type { Arc, PieArcDatum } from 'd3-shape';

import { INACTIVE_FILL_OPACITY_PIE_CHART } from '../../core/constants.js';
import { useFormatter } from '../context/FormatterContext.js';
import { useSliceHandlers } from '../hooks/useSliceHandlers.js';
import { InternalSliceData } from '../types/internal/pie-chart.js';

export interface PieSliceProps {
  sliceId: string;
  arc: PieArcDatum<InternalSliceData>;
  data: InternalSliceData;
  path: Arc<unknown, PieArcDatum<InternalSliceData>>;
  isHighlighted: boolean;
}

export const PieChartSlice = (props: PieSliceProps) => {
  const { sliceId, arc, data, path, isHighlighted } = props;
  const arcPath = path(arc);
  const formatter = useFormatter();
  const { onMouseClickHandler, onPointerMoveHandler } = useSliceHandlers(
    sliceId,
    data,
    formatter,
  );

  return (
    <g onPointerMove={onPointerMoveHandler} onClick={onMouseClickHandler}>
      <path
        d={arcPath || ''}
        fill={data.color.Default}
        opacity={isHighlighted ? 0.85 : INACTIVE_FILL_OPACITY_PIE_CHART}
      />
    </g>
  );
};
PieChartSlice['displayName'] = 'PieChartSlice';
